import styled from "styled-components";

export const BuscarPessoasWrapper = styled.div`
    display: flex;
    justify-content: center;
`;